import axios from "../../utils/axios";
import { API_SUFFIX } from "../../config/app";

// 获取设备列表
export function apiEquipmentList(query) {
    return axios({
        url: "/admin/index/eq_list" + API_SUFFIX,
        method: "get",
        params: query
    })
}

// 获取项目列表
export function apiProjectList(query) {
    return axios({
        url: "/admin/index/pr_list" + API_SUFFIX,
        method: "get",
        params: query
    })
}

// 获取新装任务列表
export function apiNewTaskList (query) {
    return axios({
        url: "/admin/index/new_tasklist" + API_SUFFIX,
        method: "get",
        params: query
    })
}

// 获取维修任务列表
export function apiMaintenanceTaskList(query) {
    return axios({
        url: "/admin/index/wx_tasklist" + API_SUFFIX,
        method: "get",
        params: query
    })
}

// 获取巡查任务列表
export function apiPatrolTaskList(query) {
    return axios({
        url: "/admin/index/xc_tasklist" + API_SUFFIX,
        method: "get",
        params: query
    })
}